module.exports = __webpack_public_path__ + "img/Homepage-icon.5f5b19fb.svg";